import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import routes from './Routes';
import GoatCounterTracking from '../analytics/GoatCounterTracking';

import AppRoute from './AppRoute';
import AuthenticationRoute from './AuthenticationRoute';

// import Login from '@authentication/login/Login';
import Registration from '../../pages/authentication/Registration';
import GettingsStarted from '../../pages/app/GettingStarted';
import AuthProvider from '../authentication/AuthProvider';
import Login from '../../pages/authentication/Login';
import { UserProfileProvider } from '../../hooks/useUserProfile';
import ProfilePage from '../../pages/app/ProfilePage';
import OnboardingRoute from './OnboardingRoute';
import Finish from '../../pages/app/OnboardingCompletion';
// import Forgot from '@authentication/forgot/Forgot';
// import Reset from '@authentication/reset/Reset';
// import Verify from '@authentication/verify/Verify';
import MatchingPage from '../../pages/app/MatchingPage';
import { HardMatchesProvider } from '../../hooks/useHardMatches';
import Forgot from '../../pages/authentication/Forgot';
import Reset from '../../pages/authentication/Reset';
import PublicProfilePage from '../../pages/app/PublicProfilePage';
import MatchDetailsPage from '../../pages/app/MatchDetailsPage';

const Router: React.FC = (() => {
    return (

        <AuthProvider>
            <UserProfileProvider>
                <HardMatchesProvider>
                    <BrowserRouter basename="/app">
                        <GoatCounterTracking />
                        <Routes>
                            {/* Authentication */}
                            <Route path="/" element={<AuthenticationRoute />} >
                                <Route path={routes.authentication.login.template} element={<Login />} /> {/*Consider removing AuthenticationRoute and checking the auth state inside the component*/}
                                <Route path={routes.authentication.registration.template} element={<Registration />} />
                                <Route path={routes.authentication.forgot.template} element={<Forgot />} />
                                <Route path={routes.authentication.reset.template} element={<Reset />} />
                            </Route>

                            {/* App */}
                            <Route path="/" element={<AppRoute />}>
                                <Route path={routes.app.profilePage.template} element={<ProfilePage />} />
                                <Route path={routes.app.finish.template} element={<Finish />} />
                                <Route path={routes.app.matches.template} element={<MatchingPage />} />
                                <Route path={routes.app.matchDetails.template} element={<MatchDetailsPage />} />

                                {Object.values(routes.app.profile).map((route) => (
                                    <Route key={route.template} path={route.template} element={<ProfilePage page={route.key} />} />
                                ))}
                            </Route>

                            {/* Onboarding */}
                            <Route path="/" element={<OnboardingRoute />} >
                                <Route path={routes.app.gettingStarted.template} element={<GettingsStarted />} />
                            </Route>

                            {/* Public Profile */}
                            <Route path={routes.app.publicProfile.template} element={<PublicProfilePage />} />

                            {/* Set registration as the entry route */}
                            <Route index element={<Navigate to={routes.authentication.registration.build()} />} />

                            {/* Catch-all route for 404 - redirect to registration */}
                            <Route path="*" element={<Navigate to={routes.authentication.registration.build()} />} />
                        </Routes>
                    </BrowserRouter>
                </HardMatchesProvider>
            </UserProfileProvider>
        </AuthProvider>
    );
});

export default Router;
